import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import OldData from "./pages/OldData";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";


function App() {
  return (
    <Router>
      <Routes>
        {/* Login Sayfası */}
        <Route path="/" element={<Login />} />

        {/* Dashboard Sayfası */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Dashboard Sayfası */}
        <Route
          path="/old-data"
          element={
            <ProtectedRoute>
              <OldData />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
